export class NumberHelper {
    public static convertToPaddedString(number: number) {
        return ("0" + number).slice(-2);
    }
}
